export default "__VITE_ASSET__dbc05e5a__"